module.exports = __webpack_public_path__ + "static/rothenberg-hex-200b578e5b31afda2522cd1e38d2ae1b.png";